<template>
    <div class="flex flex-col md:flex-row h-screen items-center">
      <div class="hidden lg:block w-full md:w-1/2 xl:w-2/3 h-screen">
          <img src="../assets/images/bg-login.png" alt="" class="w-full h-full object-cover"/>
      </div>    
      <div class="w-full md:max-w-md lg:max-w-full md:mx-auto md:mx-0 md:w-1/2 xl:w-1/3 h-screen px-6 lg:px-16 xl:px-12 flex items-center justify-center bg-white">
        <div class="w-full h-100">
          <h1 class="text-xl md:text-2xl font-bold leading-tight mt-12 text-center text-black">Reset Password</h1>
          <form class="mt-6" @submit.prevent="resetPassword">
            <label class="block text-black">Email</label>
            <input type="email" name="email" v-model="user.email"   placeholder="Enter Email" class="w-full px-4 py-3 rounded-lg bg-gray-200 mt-2 border focus:border-blue-500 focus:bg-white focus:outline-none shadow-inner text-black" required />

            <div class="mt-4">
                <label class="block text-black">Password</label>
                <div class="flex flex-wrap items-stretch w-full relative h-15 items-center">
                  <input :type="type" name="password" v-model="user.password" placeholder="Enter Password" minLength=8 class="flex-shrink flex-grow flex-auto leading-normal w-px  rounded px-4 py-3  bg-gray-200 mt-2 border focus:border-blue-500 focus:bg-white focus:outline-none shadow-inner text-black" required />
                
                  <span @click="showPassword()" class="absolute inset-y-0 right-0 flex items-center pr-3">
                  <i :class="icon"></i>
                  </span>
                </div>
            </div>

            <div class="mt-4">
                <label class="block text-black">Password Confirmation</label>
                <div class="flex flex-wrap items-stretch w-full relative h-15 items-center">
                  <input :type="type" name="password" v-model="user.password_confirmation" placeholder="Enter Password" minLength=8 class="flex-shrink flex-grow flex-auto leading-normal w-px  rounded px-4 py-3  bg-gray-200 mt-2 border focus:border-blue-500 focus:bg-white focus:outline-none shadow-inner text-black" required />
                
                  <span @click="showPassword()" class="absolute inset-y-0 right-0 flex items-center pr-3">
                  <i :class="icon"></i>
                  </span>
                </div>
              </div>
            <button type="submit" class="w-full block bg-amber-500 hover:bg-red-400 focus:bg-red-400 text-white font-semibold rounded-lg px-4 py-3 mt-6"> 
                <svg aria-hidden="true" role="status" class="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="loading">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                </svg>
                Send
            </button>
          </form>

        
        </div>
      </div>
  </div>
</template>
<script>
  import Swal from "sweetalert2";
  import AuthService from "../services/auth.service";
  export default {
    name: "reset-password-page",
    data() {
      return {
        loading: false,
        user: {
          tenant_id: "",
          email: "",
          password:"",
          password_confirmation:""

        },
        type: "password",
        showOrHide: "Show",
        icon: "fa fa-eye-slash",
        message: "",
        is_verify_view: false,
      };
    },
    computed:{
      dataUser() {
        return JSON.parse(localStorage.getItem('tenantId'));
      },
    },
    mounted() {
  
      if(this.dataUser == null){
        AuthService.getDataTenant().then(
          (response) => {
            var data = response.data;
            this.user.tenant_id = data.id;
          },
          (error) => {
            this.content =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }else{
        this.user.tenant_id = this.dataUser;
      }
    },
    methods: {
        showPassword: function () {
        if (this.type == "password") {
            this.type = "text";
            this.showOrHide = "Hide";
            this.icon = "fa fa-eye";
        } else {
            this.type = "password";
            this.showOrHide = "Show";
            this.icon = "fa fa-eye-slash";
        }
        },
        resetPassword() {
        this.loading = true;
      
        AuthService.resetPassword(this.user).then(
          (response) => {
            console.log(response.message);
            Swal.fire({
            title: response.message,
            icon: "success",
            showCancelButton: false,
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: "bg-black hover:bg-black text-white font-bold py-2 px-4 rounded",
            },
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.$router.push({
                        path: '/login',
                    });
                }
            })
            
          },
          (error) => {
            this.loading = false;
            Swal.fire({
              text: error.response.data.message,
              icon: "warning",
              customClass: {
                confirmButton: "btn fw-bold btn-danger",
              },
            });
          }
        );
      },
      
    },
  };
  </script>